import { BaseModel } from "./../../models/base-model";
import { getBaseIconResourceUrl } from '../util'
export interface IAppSetting {
  ResourceUrl?: string;
  GroupIconFilePath?: string;
  FolderIconFilePath?: string;
  CurrentLanguageCode?: string;
}

export class BaseAppSetting extends BaseModel<IAppSetting>
  implements IAppSetting {
  ResourceUrl?: string;
  GroupIconFilePath?: string;
  FolderIconFilePath?: string;
  CurrentLanguageCode?: string;
  constructor(options?: IAppSetting) {
    super(options);
  }
}

export class DefaultAppSetting extends BaseAppSetting {
  constructor() {
    super({
      ResourceUrl: getBaseIconResourceUrl(),
      FolderIconFilePath: "Document/folder.png",
      GroupIconFilePath: "Document/group.png",
      CurrentLanguageCode: localStorage.getItem('lang')
    });
  }
}

export class AppSettingStored {
  private static appSetting: IAppSetting;
  constructor(options?: IAppSetting) {
    AppSettingStored.appSetting = options;
  }

  static instance(): IAppSetting {
    return AppSettingStored.appSetting || new DefaultAppSetting();
  }
}
